import { createSlice } from '@reduxjs/toolkit'
import { IPaymentType, IRedux } from '../types'

const initialState: IRedux['checkout'] = {
  payment_type: null,
  card: { id: '', mask: '', cardMask: '' },
  accommodation: '',
  apartment: '',
  building: '',
  floor: '',
  description: '',
  destination: '',
  future_time: null,
  is_courier_call: true,
  is_operator_call: true,
  is_preorder: false,
  // not in this context but doesnt worth for another slice
  city: '',
}

const checkoutSlice = createSlice({
  name: 'checkout',
  initialState,
  reducers: {
    saveCard: (state, action) => {
      state.card = action.payload
    },
    setCity: (state, action) => {
      state.city = action.payload
    },
    changePaymentType: (state, action: { payload: IPaymentType | null }) => {
      state.payment_type = action.payload
    },
    changeDestination: (state, action) => {
      state.destination = action.payload
    },
    changeAccommodation: (state, action) => {
      state.accommodation = action.payload
    },
    changeApartment: (state, action) => {
      state.apartment = action.payload
    },
    changeBuilding: (state, action) => {
      state.building = action.payload
    },
    changeFloor: (state, action) => {
      state.floor = action.payload
    },
    changeDescription: (state, action) => {
      state.description = action.payload
    },
    changeFutureTime: (state, action) => {
      state.future_time = action.payload
      state.is_preorder = action.payload ? true : false
    },
    clearFutureTime: (state) => {
      state.future_time = null
      state.is_preorder = false
    },
    changeCourierCall: (state, action) => {
      state.is_courier_call = action.payload
    },
    changeOperatorCall: (state, action) => {
      state.is_operator_call = action.payload
    },
    clear: () => ({ ...initialState }),
  },
})

export default checkoutSlice.reducer
export const checkoutActions = checkoutSlice.actions
